import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {selectServerData} from '../DebtAndUpdatePaymentBlockSlice';

export const useSelectedBansForUpdatePayment = () => {
  const allBans = useSelector(selectServerData);
  const selectedBansForPaymentUpdate = useSelector((state) => state.debtAndUpdatePayment.selectedBansForPaymentUpdate);

  return useMemo(
    () =>
      (selectedBansForPaymentUpdate ?? [])
        .map((banNumber) => allBans.find((ban) => ban.banNumber === banNumber))
        .filter(Boolean),
    [allBans, selectedBansForPaymentUpdate],
  );
};
